module.exports = __webpack_public_path__ + "static/media/hosting-advice.8d5405dc.png";